import React from 'react';
import Chart from 'react-apexcharts';
import MuiTypography from '@mui/material/Typography';
import { Box } from '@mui/material';
import { traducciones } from '../../views/pages/operator/ProductionRecordsPage';
import { useTheme } from '@mui/material/styles';

const ParetoDefectTypesChart = ({ chartData, height = 350, showLabel = true, isDarkMode = false, showToolbar = true }) => {
    const theme = useTheme();
    if (!chartData) return null;

    const fontFamily = `Inter, sans-serif`;
    const LINE_COLOR = theme.palette.secondary.dark;
    const AXIS_COLOR = isDarkMode ? '#FFFFFF' : theme.palette.grey[700];

    const series = [
        {
            name: 'Cantidad',
            type: 'column',
            data: chartData?.quantities || []
        },
        {
            name: '% Acumulado',
            type: 'line',
            data: chartData?.cumulativePercentages || []
        }
    ];

    const options = {
        chart: {
            height: height,
            type: 'line',
            locales: [traducciones],
            defaultLocale: 'es',
            animations: {
                enabled: false
            },
            fontFamily,
            toolbar: {
                show: showToolbar,
                export: {
                    csv: {
                        filename: `Gráfico de Pareto de defectos por turno activo.`,
                        headerCategory: 'Defectos'
                    },
                    svg: { filename: `Gráfico de Pareto de defectos por turno activo.` },
                    png: { filename: `Gráfico de Pareto de defectos por turno activo.` }
                }
            }
        },
        noData: {
            text: 'No hay datos disponibles',
            align: 'center',
            verticalAlign: 'middle',
            style: {
                color: AXIS_COLOR,
                fontSize: '16px',
                fontFamily: fontFamily
            }
        },
        stroke: {
            width: [0, 3]
        },
        dataLabels: {
            enabled: true,
            enabledOnSeries: [1],
            style: {
                fontFamily,
                fontSize: '16px'
            },
            formatter: function (val, opts) {
                if (opts.seriesIndex === 1) {
                    return `${val}%`;
                }
                return val;
            }
        },
        labels: chartData.categories,
        xaxis: {
            labels: {
                formatter: (val) => {
                    if (typeof val !== 'string') return val;

                    const parts = val.split('#');
                    return parts.length > 1 ? parts[1] : val;
                },
                style: {
                    colors: AXIS_COLOR,
                    fontSize: '16px'
                }
            },
            categories: chartData.categories,
            title: {
                text: 'Defectos',
                style: {
                    fontFamily,
                    color: AXIS_COLOR,
                    fontSize: '16px'
                }
            },
            axisBorder: {
                show: true,
                color: AXIS_COLOR
            },
            axisTicks: {
                show: true,
                color: AXIS_COLOR
            }
        },
        yaxis: [
            {
                title: {
                    text: 'Cantidad',
                    style: {
                        fontFamily,
                        color: AXIS_COLOR,
                        fontSize: '16px'
                    }
                },
                labels: {
                    style: {
                        fontFamily,
                        colors: AXIS_COLOR,
                        fontSize: '16px'
                    }
                }
            },
            {
                opposite: true,
                min: 0,
                max: 100,
                tickAmount: 5,
                title: {
                    text: '% Acumulado',
                    style: {
                        fontFamily,
                        color: AXIS_COLOR,
                        fontSize: '16px'
                    }
                },
                labels: {
                    formatter: (val) => `${val}%`,
                    style: {
                        fontFamily,
                        colors: AXIS_COLOR,
                        fontSize: '16px'
                    }
                }
            }
        ],
        tooltip: {
            theme: 'dark',
            shared: true,
            intersect: false,
            style: {
                fontFamily,
                fontSize: '16px'
            },
            y: [
                {
                    formatter: (val) => `${val} piezas`
                },
                {
                    formatter: (val) => `${val}%`
                }
            ]
        },
        legend: {
            position: 'bottom',
            fontFamily,
            fontSize: '16px',
            labels: {
                colors: AXIS_COLOR
            }
        },
        colors: ['#084e46', LINE_COLOR]
    };

    return (
        <Box style={{ p: 1 }}>
            {showLabel && (
                <MuiTypography variant="h5" sx={{ fontWeight: 400, textAlign: 'center', color: 'gray' }}>
                    Pareto de Defecto por turno.
                </MuiTypography>
            )}
            <Chart options={options} series={series} type="line" height={height} />
        </Box>
    );
};

export default ParetoDefectTypesChart;
